module.exports = __webpack_public_path__ + "static/img/total-AI.e39c6e96.png";